<!-- eslint-disable no-mixed-spaces-and-tabs -->
<!-- src/components/LandingScreen.vue -->
<template class="dark:bg-[#1F2937]">
  <div class='flex space-x-2 justify-center items-center  h-screen   '>
 	
 	<span class='sr-only'>...</span>
  	<div class='h-8 w-8 bg-[#B99269]  rounded-full animate-bounce [animation-delay:-0.3s]'></div>
	<div class='h-8 w-8 bg-[#B99269] rounded-full animate-bounce [animation-delay:-0.15s]'></div>
	<div class='h-8 w-8 bg-[#B99269] rounded-full animate-bounce'></div>
</div>
</template>

<script setup>
</script>

<style scoped>
/* Add any specific styles for the loading screen here */
</style>
